import React from "react"

//-------Corporative
import BrandsHotels from "./views/corporative/BrandsHotels";
import RegionsCities from "./views/corporative/RegionsCities";
import CorporativeCatalogs from "./views/corporative/CorporativeCatalogs";
import CorporativeParsing from "./views/corporative/CorporativeParsing";
import Roles from "./views/corporative/Roles";
import Users from "./views/corporative/Users";

//-------Property
import Catalogs from "./views/property/Catalogs";
import CutOffDate from "./views/property/CutOffDate";
import Expressions from "./views/property/Expressions";
import ImportData from "./views/property/ImportData";
import ParsingDB from "./views/property/ParsingDB";
import Seasons from "./views/property/Seasons";


class Layout extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            }
    }

    render() {
        return (
            <div className="layout">
                <div className={"brands-hotels "  + (this.props.app.state.section_active !== "brands-hotels" ? "section-hide" : "section-show")}>
                    <BrandsHotels
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                        getHotels = {this.props.getHotels}
                    />
                </div>
                <div className={"regions-cities "  + (this.props.app.state.section_active !== "regions-cities" ? "section-hide" : "section-show")}>
                    <RegionsCities
                        handleNotification = {this.props.handleNotification}
                        activeSection={this.props.activeSection}
                        item_active={this.props.item_active}
                    />
                </div>
                <div className={"corporative-catalogs "  + (this.props.app.state.section_active !== "corporative-catalogs" ? "section-hide" : "section-show")}>
                    <CorporativeCatalogs
                        catalogs={this.props.catalogs}
                        activeSection={this.props.activeSection}
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                     />
                </div>
                <div className={"corporative-parsing "  + (this.props.app.state.section_active !== "corporative-parsing" ? "section-hide" : "section-show")}>
                    <CorporativeParsing
                        catalogs={this.props.catalogs}
                        activeSection={this.props.activeSection}
                        refreshCatalogSys={this.props.refreshCatalogSys}
                        activeSection={this.props.activeSection}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                    />
                </div>
                <div className={"roles "  + (this.props.app.state.section_active !== "roles" ? "section-hide" : "section-show")}>
                    <Roles
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                    />
                </div>
                <div className={"users "  + (this.props.app.state.section_active !== "users" ? "section-hide" : "section-show")}>
                    <Users
                        handleNotification = {this.props.handleNotification} 
                        item_active={this.props.item_active}
                    />
                </div>
                
                <div className={"catalogs "  + (this.props.app.state.section_active !== "catalogs" ? "section-hide" : "section-show")}>
                    <Catalogs 
                        app={this.props.app}
                        catalogs={this.props.catalogs}
                        handleNotification = {this.props.handleNotification}
                        renderSelectHotels = {this.props.renderSelectHotels}
                        hotel_selected = {this.props.hotel_selected}
                        item_active = {this.props.item_active}
                        activeSection={this.props.activeSection}
                    />
                </div>
                <div className={"cut-off-date "  + (this.props.app.state.section_active !== "cut-off-date" ? "section-hide" : "section-show")}>
                    <CutOffDate 
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                    />
                </div>
                <div className={"expressions "  + (this.props.app.state.section_active !== "expressions" ? "section-hide" : "section-show")}>
                    <Expressions 
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                    />
                </div>
                <div className={"import-data "  + (this.props.app.state.section_active !== "import-data" ? "section-hide" : "section-show")}>
                    <ImportData 
                        app={this.props.app}
                        renderSelectHotels={this.props.renderSelectHotels}
                        setActiveHotel = {this.props.setActiveHotel}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                    />
                </div>
                <div className={"parsing-db "  + (this.props.app.state.section_active !== "parsing-db" ? "section-hide" : "section-show")}>
                    <ParsingDB 
                        app={this.props.app}
                        catalogs={this.props.catalogs}
                        refreshCatalogSys={this.props.refreshCatalogSys}
                        renderSelectHotels={this.props.renderSelectHotels}
                        activeSection={this.props.activeSection}
                        handleNotification = {this.props.handleNotification}
                        hotel_selected = {this.props.hotel_selected}
                        item_active = {this.props.item_active}
                    />
                </div>
                <div className={"seasons "  + (this.props.app.state.section_active !== "seasons" ? "section-hide" : "section-show")}>
                    <Seasons 
                        app={this.props.app}
                        handleNotification = {this.props.handleNotification}
                        item_active={this.props.item_active}
                    />
                </div>
                
            </div>
        )
    }

}

export default Layout


// WEBPACK FOOTER //
// ./src/Setup/modules/setup/Layout.js